import React, { useContext, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { AdminAuthContext } from "../context/AdminAuthContext";

export const RequireAdminAuth: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { admin } = useContext(AdminAuthContext);
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
};

export const RequireNoAdminAuth: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { admin } = useContext(AdminAuthContext);
  if (admin) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return <>{children}</>;
};
